<template>
  <span
    class="attached-to-positions-counter"
    :class="{ 'attached-to-positions-counter--muted': isMuted }"
  >
    <span class="attached-to-positions-counter__icon" aria-hidden="true">
      <svg
        class="attached-to-positions-counter__desk-frame"
        preserveAspectRatio="none"
        overflow="visible"
        viewBox="0 0 22.9286 18.5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.1786 17.75V2.75C22.1786 1.64543 21.2831 0.75 20.1786 0.75H2.75C1.64543 0.75 0.75 1.64543 0.75 2.75V14.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M0.75 5.75L22.1786 5.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        class="attached-to-positions-counter__desk-drawers"
        preserveAspectRatio="none"
        overflow="visible"
        viewBox="0 0 11.2139 13.1431"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.75 0.75V10.3931C0.75 11.4976 1.64543 12.3931 2.75 12.3931H8.46387C9.56844 12.3931 10.4639 11.4976 10.4639 10.3931V0.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M4.39258 3.39307H6.82104"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.39258 9.39307H6.82104"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.46387 6.39307L10.4639 6.39307"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    <span class="attached-to-positions-counter__count">{{ count }}</span>
  </span>
</template>

<script setup>
import { computed } from "vue";

/**
 * ER-11383 — AttachedToPositionsCounterButton.
 *
 * Read-only shared counter for "# Positions" table cells: the Figma "Positions"
 * desk glyph (node 46407:320, Group 8875 / Group 8876) plus the number of
 * positions attached to the row. Icon + number only, with NO border, background
 * fill or pill chrome in any state.
 *
 * Visual state: text/icon are brand purple #6941C6 when the count is greater
 * than 0 and the row is enabled; muted grey #98A2B0 when the count is 0 or the
 * row is disabled (Retired/Disabled rows in JobCategoriesList). The desk glyph
 * is drawn with currentColor so it inherits the same state colour as the count.
 *
 * No events, no slots, no click target. The parent resolves the count and the
 * disabled state from its row data (see JobCategoriesList → buildRowView).
 */
const props = defineProps({
  count: {
    type: Number,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const isMuted = computed(() => props.disabled || props.count === 0);
</script>

<style scoped>
.attached-to-positions-counter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #6941c6;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-variant-numeric: tabular-nums;
}

.attached-to-positions-counter__icon {
  position: relative;
  display: block;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  overflow: hidden;
}

.attached-to-positions-counter__desk-frame {
  position: absolute;
  left: 1.29px;
  top: 4px;
  width: 21.429px;
  height: 17px;
  display: block;
}

.attached-to-positions-counter__desk-drawers {
  position: absolute;
  left: 1.29px;
  top: 9.36px;
  width: 9.714px;
  height: 11.643px;
  display: block;
}

.attached-to-positions-counter__count {
  line-height: 20px;
}

.attached-to-positions-counter--muted {
  color: #98a2b0;
}
</style>
